//mockData

export const postData = [
  {
    id: 1,
    location: "台北",
    account: "Hide_On_Bush",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a5.png",
    photo: "/react-ts-frontend-ig-clone/images/posts/main5.png",
    likes: 98,
    description: "睡過頭做到台北101站啦 RRRR",
    hashTags: "#出事了",
    createTime: "1 HOURS AGO",
  },
  {
    id: 2,
    location: "國立成功大學",
    account: "Jessica0608",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a1.png",
    photo: "/react-ts-frontend-ig-clone/images/posts/main1.png",
    likes: 939,
    description: "回來成大了！ 距離畢業也快兩年了呢",
    hashTags: "#NCKU",
    createTime: "3 HOURS AGO",
  },
  {
    id: 3,
    location: "嘉義",
    account: "zoe_0200",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a4.png",
    photo: "/react-ts-frontend-ig-clone/images/posts/main2.png",
    likes: 824,
    description: "撬掉期末考來一場說走就走的旅行~",
    hashTags: "#教授對不起",
    createTime: "7 HOURS AGO",
  },
  {
    id: 4,
    location: "安平古堡",
    account: "__x_x__",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a2.png",
    photo: "/react-ts-frontend-ig-clone/images/posts/main4.png",
    likes: 167,
    description: "那些曾駐留此地的荷蘭東印度公司員工, 可曾想過400年後的光景",
    hashTags: "#台南",
    createTime: "10 HOURS AGO",
  },
  {
    id: 5,
    location: "台灣台北市內湖區碧山",
    account: "gogo_0214",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a3.png",
    photo: "/react-ts-frontend-ig-clone/images/posts/main3.png",
    likes: 777,
    description: "攝影練習中",
    hashTags: "#台北",
    createTime: "22 HOURS AGO",
  },
];

export const storyData = [
  {
    id: 1,
    name: "Jessica0608",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a1.png",
    picture: "https://images.unsplash.com/photo-1604629142630-11d209431dd7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80",
  },
  {
    id: 2,
    name: "__x_x__",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a2.png",
    picture: "https://images.unsplash.com/photo-1586331379632-a205c01f9fc8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=332&q=80",
  },
  {
    id: 3,
    name: "gogo_0214",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a3.png",
    picture: "https://images.unsplash.com/photo-1601404385088-68d68e7e36d4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: 4,
    name: "zoe_0200",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a4.png",
    picture: "https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=389&q=80",
  },
  {
    id: 5,
    name: "Hide_On_Bush",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a5.png",
    picture: "https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80",
  },
  {
    id: 6,
    name: "louis",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a6.png",
    picture: "https://images.unsplash.com/photo-1564166174574-a9666f590437?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: 7,
    name: "alvin",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a7.png",
    picture: "https://images.unsplash.com/photo-1601534622119-e9b3aa7c7bdf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: 8,
    name: "grace",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a8.png",
    picture: "https://images.unsplash.com/photo-1564202372268-daf356103533?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: 9,
    name: "rance",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a9.png",
    picture: "https://images.unsplash.com/photo-1544294932-57834439d0ba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    id: 10,
    name: "bruce_fe",
    avatar: "/react-ts-frontend-ig-clone/images/avatars/a10.png",
    picture: "https://images.unsplash.com/photo-1607242792481-37f27e1d74e1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
];